export default __webpack_public_path__ + "static/media/promoUp.b69b9291.png";